module.exports = __webpack_public_path__ + "static/media/03-1-galeria-03-balenciaga-mobile@2x.1b977961.jpg";